import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { CanLoad } from '@angular/router';
import { MenuController, NavController } from '@ionic/angular';
import { AuthProvider } from 'src/app/services/shared/autorizacion';
import { itmCategoria } from 'src/app/models/auth-data.model';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  @ViewChild('primerMenu') primerMenu: MenuController;

  lstModulos: itmCategoria[] = [];
  disabled = false;
  constructor(
    public authService: AuthProvider,
    private navCtrl: NavController,
  ) { }


  async ngOnInit() { }

  public async toogleSection(IdCategoriaModulo: number) {

    const currentModulo = this.authService.passCard.LstCategoriasModulos.find(f => f.IdCategoriaModulo === IdCategoriaModulo);
    const toogle = !currentModulo.opened;
    this.authService.passCard.LstCategoriasModulos.forEach(f => {
      if (f.IdCategoriaModulo)
        f.opened = false
    })
    currentModulo.opened = toogle;
    const resultado = await this.authService.guardarCredenciales();

  }

  ionViewWillEnter() {
    // console.log('ionViewWillEnter MenuComponent', this.authService.passCard);
    if (this.authService.passCard) {
      this.lstModulos = this.authService.passCard.LstCategoriasModulos;
    }
  }

  async navigateModule(strComponente: string) {

    const currentModulo = this.authService.passCard.LstModulos.find(f => f.component === strComponente);
    const toogle = !currentModulo.selected;
    this.authService.passCard.LstModulos.forEach(f => {
      if (f.IdCategoriaModulo)
        f.selected = false
    })
    currentModulo.selected = toogle;
    const resultado = await this.authService.guardarCredenciales();



    this.navCtrl.navigateRoot(strComponente, { animated: true });
    this.primerMenu.close().then(async (dataClose) => {
    });

  }

  async logOut() {
    await this.authService.logout();
    this.primerMenu.close().then(async (dataClose) => {
    });
  }

}
